import { render } from "./LocationDirectoryComponent.vue?vue&type=template&id=bb0354f4&ts=true"
import script from "./LocationDirectoryComponent.vue?vue&type=script&lang=ts"
export * from "./LocationDirectoryComponent.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\Website\\wwwroot\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__